const hasLower = (s: string, locale?: string) => s !== s.toLocaleUpperCase(locale);

const upperFirst = (s: string, locale?: string) => s.charAt(0).toLocaleUpperCase(locale) + s.slice(1);

// Words with a digit are codes ("23G", "12Α") and stay as stored.
const hasDigit = (word: string) => /\d/.test(word);

// Display-only casing for names: ALL-CAPS words (legacy imports) become Title case, word by word.
// Mixed-case words, codes and initials ("Γ.Κ.") stay as stored; the first letter is always upper.
export function capitalizeFirst(input: string, locale?: string) {
  if (!input) return '';
  const cased = input
    .split(/(\s+)/)
    .map((word) => {
      if (hasDigit(word) || hasLower(word, locale)) return word;
      return word
        .toLocaleLowerCase(locale)
        .replace(/(^|[^\p{L}])(\p{L})/gu, (_, sep: string, ch: string) => sep + ch.toLocaleUpperCase(locale));
    })
    .join('');
  return upperFirst(cased, locale);
}

// Display-only casing for free text (descriptions, titles): ALL-CAPS text becomes sentence case.
// Mixed-case text stays as stored apart from its first letter.
export function sentenceCase(input: string, locale?: string) {
  if (!input) return '';
  if (hasLower(input, locale)) return upperFirst(input, locale);
  const lowered = input
    .split(/(\s+)/)
    .map((word) => (hasDigit(word) ? word : word.toLocaleLowerCase(locale)))
    .join('');
  return upperFirst(lowered, locale);
}
